import { useRoute, useRouter } from '#imports'

import {
  landingReviewsAPI,
  productListPageAPI,
  productReviewsAPI,
  reviewsAPI,
  sellerReviewsAPI,
} from '@backmarket/http-api'
import { getMerchantShop } from '@backmarket/http-api/src/api-specs-navigation-experience/merchant-shop/merchant-shop'

import { PRODUCT } from '~/scopes/product/route-names'
import { ROUTES as PRODUCT_LIST_ROUTES } from '~/scopes/product-list/route-names'
import { useLinkBooster } from '~/scopes/seo/composables/useLinkBooster'

import { ROUTES } from '../../route-names'

// TODO Use dedicated service to request the title once it has been created
export function useRequests() {
  const route = useRoute()
  const router = useRouter()
  const { fetchLinkBoosters } = useLinkBooster()

  switch (route.name) {
    case PRODUCT.MASTER_PP:
    case PRODUCT.HOME:
      return {
        ...productReviewsAPI,
        headers: { 'BM-Page-Name': route.name },
        hasAIReviewsSummary: true,
      }

    case ROUTES.PAGES.LANDING:
    case PRODUCT_LIST_ROUTES.PRODUCT_LIST:
      return {
        ...landingReviewsAPI,
        getTitle: productListPageAPI.getProductListPage,
        getSeoLinks: () =>
          fetchLinkBoosters({
            sourceUrl: router.resolve({
              name: PRODUCT_LIST_ROUTES.PRODUCT_LIST,
              params: route.params,
            }).href,
            listType: 'plp_linkboosters',
          }),
      }

    case ROUTES.PAGES.MERCHANT:
      return {
        ...sellerReviewsAPI,
        getTitle: getMerchantShop,
      }

    case ROUTES.PAGES.ALL:
      return reviewsAPI

    default:
      return undefined
  }
}
